export const Primary = (props) => {
  return (
    <div>
      <button
        style={{ cursor: "pointer" }}
        type="button"
        className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-xs text-md font-semibold text-white bg-purple transition duration-300 hover:bg-purpleDark focus:outline-hidden"
      >
        <div className="flex">
          {props.text}
          <div className="grid content-center pl-2">{props.icon}</div>
        </div>
      </button>
    </div>
  );
};
